import type * as Types from '../../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetSubscriptionQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetSubscriptionQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly tokensCount: number, readonly subscription: { readonly __typename?: 'YalperSubscription', readonly activeSubscription: boolean, readonly beginDate?: string | null, readonly endDate?: string | null, readonly planId?: number | null }, readonly currentAccountsPriceInfo: { readonly __typename?: 'YalperAccountsPriceInfo', readonly price?: number | null, readonly count?: number | null } } | null };

export type GetCurrentUserQueryVariables = Types.Exact<{
  count: Types.Scalars['Int']['input'];
  addToCurrentPeriod: Types.Scalars['Boolean']['input'];
}>;


export type GetCurrentUserQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly accountsPriceInfo: { readonly __typename?: 'YalperAccountsPriceInfo', readonly price?: number | null }, readonly paymentMethods: ReadonlyArray<{ readonly __typename?: 'YalperPaymentMethod', readonly id?: number | null, readonly paymentSystem: Types.YalperPaymentSystem, readonly last4: string, readonly isExpired: boolean }> } | null };


export const GetSubscriptionDocument = gql`
    query GetSubscription {
  currentUser {
    tokensCount
    subscription {
      activeSubscription
      beginDate
      endDate
      planId
    }
    currentAccountsPriceInfo {
      price
      count
    }
  }
}
    `;

/**
 * __useGetSubscription__
 *
 * To run a query within a React component, call `useGetSubscription` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscription({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscription(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
      }
export function useGetSubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export function useGetSubscriptionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>(GetSubscriptionDocument, options);
        }
export type GetSubscriptionHookResult = ReturnType<typeof useGetSubscription>;
export type GetSubscriptionLazyQueryHookResult = ReturnType<typeof useGetSubscriptionLazyQuery>;
export type GetSubscriptionSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionSuspenseQuery>;
export type GetSubscriptionQueryResult = Apollo.QueryResult<GetSubscriptionQueryPage, GetSubscriptionQueryVariables>;
export const GetCurrentUserDocument = gql`
    query GetCurrentUser($count: Int!, $addToCurrentPeriod: Boolean!) {
  currentUser {
    accountsPriceInfo(count: $count, addToCurrentPeriod: $addToCurrentPeriod) {
      price
    }
    paymentMethods {
      id
      paymentSystem
      last4
      isExpired
    }
  }
}
    `;

/**
 * __useGetCurrentUserQuery__
 *
 * To run a query within a React component, call `useGetCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentUserQuery({
 *   variables: {
 *      count: // value for 'count'
 *      addToCurrentPeriod: // value for 'addToCurrentPeriod'
 *   },
 * });
 */
export function useGetCurrentUserQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables> & ({ variables: GetCurrentUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
      }
export function useGetCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export function useGetCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>(GetCurrentUserDocument, options);
        }
export type GetCurrentUserQueryHookResult = ReturnType<typeof useGetCurrentUserQuery>;
export type GetCurrentUserLazyQueryHookResult = ReturnType<typeof useGetCurrentUserLazyQuery>;
export type GetCurrentUserSuspenseQueryHookResult = ReturnType<typeof useGetCurrentUserSuspenseQuery>;
export type GetCurrentUserQueryResult = Apollo.QueryResult<GetCurrentUserQueryPage, GetCurrentUserQueryVariables>;